import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import { TextField, Checkbox, FormControlLabel, Icon, Grid, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, SnackbarContent } from '@material-ui/core';
import * as courseActions from '../../course/store/actions';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ScaffoldForm from './ScaffoldForm';
import BlankCourseSchedule from './BlankCourseSchedule';
import CourseBuilderHeader from '../../../components/CourseBuilderHeader';
import * as paramActions from '../../../components/paramHistory/store/actions';
import * as validatorActions from '../../../components/validator/store/actions';
import BlankUnscheduledCourse from './BlankUnscheduledCourse';
import WizardLessonList from './WizardLessonList';
import BuilderFormContainer from './BuilderFormContainer';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64
    },
    tabRoot: {
        height: 64
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '90%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
});

class CourseBuilder extends React.Component {

    constructor(props) {
        super(props);
        this.props.getAllLessons(this.props.auth.user.data.auth_id)
        const validationList = [
            {
                field_name: 'CourseName', functionName: ['checkRequiredFilled']
            }
        ]

        this.props.startValidator(validationList)
        this.props.updateCourseBuilderParams({ active: true, startingPoint: 'course' })
        this.props.loadMajors(this.props.auth.user.data.auth_id);
    }

    state = {
        lessonSearch: '',
    }

    handleSubmit = () => {
        const unsched = this.props.courseScaffold.Unscheduled;
        this.props.updateCourseBuilderParams({ lessonCycleActive: true, courseUnscheduled: unsched, lessonListWeek: unsched === 1 ? 0 : 1 })
        this.props.clearWizard()
        this.props.submitCourse(this.props.courseScaffold, this.props.mappedLessons, this.props.courseScaffold.majors.filter(m => m.selected), this.props.auth.user.data.auth_id)
    }

    handleLessonSearchChange = (data) => {
        this.setState({ lessonSearch: data })
    }

    handleSelectLesson = (l) => {
        this.handleLessonSearchChange('')
        this.props.selectLessonHub(l);
    }

    handleBackdropClick = () => {
        this.props.toggleLessonDialog(false, null)
        this.handleLessonSearchChange('')
    }


    handleNewLessonChange = field_name => event => {
        let value = event.target.value;
        const update_data = {
            [field_name]: value
        }
        this.props.updateLessonForm(update_data);
    }

    getLessonDialog = (openBool, choice) => {
        const selected_lesson_ids = this.props.mappedLessons.map(l => l.lesson_id)
        let dialogContent = <div></div>
        if (openBool && !choice) {
            dialogContent =
                <DialogContent>
                    <Grid container>
                        <Grid item xs={4}>
                            <Button onClick={() => this.props.lessonDialogChoice('choose')} variant={'contained'}>Choose Existing</Button>
                        </Grid>
                        <Grid item xs={4}>
                            <Button onClick={() => this.props.lessonDialogChoice('create')} variant={'contained'}>Create New</Button>
                        </Grid>
                        <Grid item xs={4}>
                            <Button
                                variant="contained"
                                onClick={() => this.props.toggleLessonDialog(false, null)}
                            >
                                Close
                        </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
        }
        else if (openBool && choice === 'create' || openBool && choice === 'add') {
            dialogContent =
                <DialogContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="LessonName"
                                label="Lesson Name"
                                className={this.props.classes.textField}
                                value={this.props.courseScaffold.newLesson.LessonName}
                                onChange={this.handleNewLessonChange('LessonName')}
                                margin="normal"
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="LessonDescription"
                                label="Lesson Description"
                                className={this.props.classes.textField}
                                value={this.props.courseScaffold.newLesson.LessonDescription}
                                onChange={this.handleNewLessonChange('LessonDescription')}
                                margin="normal"
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                className={this.props.classes.button}
                                onClick={() => this.props.submitNewLessonHeader(this.props.courseScaffold.newLesson, choice)}
                            >
                                Submit
                                </Button>
                            <Button
                                variant="contained"
                                className={this.props.classes.button}
                                onClick={() => this.props.toggleLessonDialog(false, null)}
                            >
                                Close
                                </Button>
                        </Grid>
                    </Grid>
                </DialogContent >
        }
        else if (openBool) {
            dialogContent =
                <DialogContent>
                    <WizardLessonList
                        Unscheduled={false}
                        lessonList={
                            this.props.allLessons
                                .filter(lesson => !selected_lesson_ids.includes(lesson.lesson_id))
                                .filter(lesson => lesson.Unscheduled === 0)
                        }
                    />
                </DialogContent>
        }

        else {
            null
        }

        return (
            <Dialog
                open={this.props.lessonDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={'md'}
                fullWidth
                onBackdropClick={() => this.handleBackdropClick()}
            >
                <DialogTitle id="alert-dialog-title">{"Lesson Hub"}</DialogTitle>
                {dialogContent}
            </Dialog >
        )
    }

    getButtonContent = (step) => {
        const lesson_ids = this.props.mappedLessons.map(lesson => lesson.lesson_id);
        const disableSave = lesson_ids.includes('blank_lesson');
        switch (step) {
            case ('blank_schedule'):
                {
                    return (
                        <div>
                            <Button
                                onClick={() => this.handleSubmit()}
                                variant="contained"
                                className={this.props.classes.button}
                                disabled={disableSave}
                            >
                                Submit
                            </Button>
                            <Button
                                onClick={() => this.props.clearWizard()}
                                variant="contained"
                                className={this.props.classes.button}
                            // disabled={disableSave}
                            >
                                Clear
                            </Button>
                        </div>
                    )
                }
            default: {
                return null
            }
        }
    }

    changeSelectedLesson = (e) => {
        this.setState({ selected_lesson_id: e.target.value })
    }

    getStepContent = (step) => {
        switch (step) {
            case ('scaffold'):
                {
                    // return <ScaffoldForm />
                    return <BuilderFormContainer />
                }
            case ('blank_schedule'):
                {
                    if (this.props.courseScaffold.Unscheduled === 1) {
                        return (
                            <BlankUnscheduledCourse
                                key={1}
                                mappedLessons={this.props.mappedLessons}
                                courseBuilder={true}
                                pushUnscheduledLesson={this.props.pushUnscheduledLesson}
                                moveUnscheduledLesson={this.props.moveUnscheduledLesson}
                                handleUnscheduledLessonDelete={this.props.deleteUnscheduledLesson}
                            />
                        )
                    }
                    else {
                        return (
                            <BlankCourseSchedule key={1} month={1} mappedLessons={this.props.mappedLessons} />
                        )
                    }

                }
            default:
                {
                    return (<div>no step</div>)
                }
        }
    }

    render() {
        const { classes } = this.props
        const content = this.getStepContent(this.props.step)
        let header_content = <CourseBuilderHeader activeStep={0} baseComponent={'course'} />
        // console.log(this.props)
        return (

            <React.Fragment>
                {/* <div className="p-24"> */}
                <div>
                    {this.getLessonDialog(this.props.lessonDialog, this.props.lessonDialogChoiceSetting)}
                    {content}
                </div>
                <div style={{ position: 'absolute', bottom: '0' }}>
                    {this.getButtonContent(this.props.step)}
                </div>
            </React.Fragment>
        )
    }
}

// {this.props.allLessons.map(l => {
//     return <MenuItem value={l.lesson_id}>{l.LessonName}</MenuItem>
// })}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateCourseScaffold: courseActions.updateCourseScaffold,
        handleDaySelect: courseActions.handleDaySelect,
        getAllLessons: courseActions.getAllLessons,
        lessonDialogChoice: courseActions.lessonDialogChoice,
        selectLessonHub: courseActions.selectLessonHub,
        updateLessonForm: courseActions.updateLessonForm,
        submitNewLessonHeader: courseActions.submitNewLessonHeader,
        submitCourse: courseActions.submitCourse,
        getCourseId: courseActions.getCourseId,
        toggleLessonDialog: courseActions.toggleLessonDialog,
        loadMajors: courseActions.getMajors,
        updateCourseBuilderParams: paramActions.updateCourseBuilderParams,
        startValidator: validatorActions.startValidator,
        pushUnscheduledLesson: courseActions.pushUnscheduledLesson,
        moveUnscheduledLesson: courseActions.moveUnscheduledLesson,
        deleteUnscheduledLesson: courseActions.deleteUnscheduledLesson,
        clearWizard: courseActions.clearWizard
    }, dispatch);
}

function mapStateToProps({ validator, courseApp, paramHistory, auth }) {
    return {
        courseScaffold: courseApp.courseBuilder.courseScaffold,
        step: courseApp.courseBuilder.step,
        mappedLessons: courseApp.courseBuilder.mappedLessons,
        lessonDialog: courseApp.courseBuilder.lessonDialog,
        allLessons: courseApp.courses.allLessons,
        lessonDialogChoiceSetting: courseApp.courseBuilder.lessonDialogChoice,
        courseBuilder: paramHistory.courseBuilder,
        validator: validator.list,
        auth
    }
}
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(CourseBuilder)));



// WEBPACK FOOTER //
// src/main/content/course/builderComponents/CourseBuilder.js